import { Component, EventEmitter, Input, OnInit, Output , ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-gmsconfirm',
    templateUrl: './gmsconfirm.component.html',
    styleUrls: ['./gmsconfirm.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GmsconfirmComponent implements OnInit {
  @Input() configObj;
  @Output() confirmed = new EventEmitter<boolean>();

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  public Onconfirmation(response) {
    let isAccepted: boolean = false;
    switch (response) {
      case 'accept':
        isAccepted = true;
        this.activeModal.close(isAccepted);
        break;
      case 'decline':
        isAccepted = false;
        this.activeModal.close(isAccepted);
        break;
      case 'dismiss':
        isAccepted = false;
        this.activeModal.dismiss();
        break;
    }

    this.confirmed.emit(isAccepted);
  }

}